export const getRowKeyValue = (item, rowKey = 'id', index = 0) => {
  if (typeof rowKey === 'function') return rowKey(item, index);

  return item?.[rowKey] ?? item?.id ?? index;
};

const normalizeSortValue = value => {
  if (value === null || value === undefined) return '';
  if (value instanceof Date) return value.getTime();
  if (typeof value === 'number') return value;

  return String(value).toLocaleLowerCase('pt-BR');
};

export const sortItems = (items = [], sortBy = '', direction = 'asc') => {
  if (!sortBy) return [...items];

  const multiplier = direction === 'desc' ? -1 : 1;

  return [...items]
    .map((item, index) => ({ item, index }))
    .sort((left, right) => {
      const leftValue = normalizeSortValue(left.item?.[sortBy]);
      const rightValue = normalizeSortValue(right.item?.[sortBy]);

      if (leftValue < rightValue) return -1 * multiplier;
      if (leftValue > rightValue) return 1 * multiplier;

      return left.index - right.index;
    })
    .map(entry => entry.item);
};

export const toggleSelectedKey = (selectedKeys, key) => {
  const keys = Array.from(selectedKeys || []);
  if (keys.includes(key))
    return keys.filter(selectedKey => selectedKey !== key);

  return [...keys, key];
};

export const resolveRowState = (item, rowStateKey = 'state') =>
  item?.[rowStateKey] || item?.rowState || item?.statusState || 'default';
